import _ from 'lodash'
import MarkerWithLabel from 'marker-with-label'
import LatLng from './LatLng';
const Marker = MarkerWithLabel(google.maps)

export default class CompanyBase {
    constructor(id, data = {}){
        const defaultData = {
            name: "Empresa",
            color: "#429BF5"
        }
        this._data = _.assign(defaultData, data)
        this._marker = new Marker({
            position: { 
                lat: 0, 
                lng: 0 
            },
            icon: {
                path: "M16 4.588l2.833 8.719H28l-7.416 5.387 2.832 8.719L16 22.023l-7.417 5.389 2.833-8.719L4 13.307h9.167L16 4.588z",
                scale: 1,
                strokeColor: "#FFF",
                strokeWeight: 2,
                fillColor: "#429BF5",
                fillOpacity: 1,
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(16, 20)
            },
            labelContent: "EMPRESA",
            labelAnchor: new google.maps.Point(60, -15),
            labelClass: "tracked-device-label", // the CSS class for the label
            clickable: false,
            zIndex: 0
        })
    }
    setMap(map){
        this._marker.setMap(map)
    }
    getMarker(){
        return this._marker
    }
    update(){

    }

    // setPosition(lat,lng){
    //     const latLng = new LatLng(lat,lng)
    //     console.log(latLng)
    //     this._marker.position = latLng
    // }
}